import { PiWarningFill } from 'react-icons/pi';
import { useDisclosure } from '@ds';
import { InfoBanner } from '@ui';
import { SectionRow } from '@features/components/CaseOverview/components';
import { CaseStatus, DonorData, DonorType, OrganType } from '@/api/apis/case';
import { OpoClinicalRequestModal } from './OpoClinicalRequestModal/OpoClinicalRequestModal';

interface OpoClinicalRequestRowProps {
  caseId: string;
  organType: OrganType;
  donorType: DonorType;
  status: CaseStatus;
  matchId?: string | null;
  donorData?: DonorData | null;
}

export const OpoClinicalRequestRow = ({
  caseId,
  organType,
  donorType,
  status,
  matchId,
  donorData,
}: OpoClinicalRequestRowProps) => {
  const { isOpen, onOpenChange } = useDisclosure();
  const hasDonorData = !!donorData;

  return (
    <>
      <SectionRow label="OPO Clinical Request">
        <div className="flex items-center gap-1">
          <button className="text-m-m text-base-5 underline" onClick={onOpenChange}>
            View
          </button>
          {!hasDonorData && <PiWarningFill className="text-warning-40" size={16} />}
        </div>
      </SectionRow>
      {!hasDonorData && (
        <InfoBanner iconType="warning" className="-mt-2">
          OPO Clinical Request needs to be updated
        </InfoBanner>
      )}
      <OpoClinicalRequestModal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        caseId={caseId}
        organType={organType}
        donorType={donorType}
        status={status}
        matchId={matchId}
        donorData={donorData}
      />
    </>
  );
};
